var map = {
	"./arrow.svg": 716,
	"./delete.svg": 365,
	"./deletegradient.svg": 366,
	"./edit.svg": 367,
	"./editgradient.svg": 368,
	"./http-off-icon.svg": 717,
	"./http-on-icon.svg": 718,
	"./view.svg": 523,
	"./viewgradient.svg": 524
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1328;